/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey } from "../utils/queryKeyHelpers";

const baseConfigurationKeys = [getBaseQueryKey(Query_Keys.configuration)];

export const configurationMutationKeyGroups = {
  create: baseConfigurationKeys,
  update: baseConfigurationKeys,
  delete: baseConfigurationKeys,
};
